import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { AdminService } from '../services/admins/admin.service';
import { Auth } from '../services/auth.service';
import { FilterService } from '../services/calls/filter.service';
import { FailedEmailService } from '../services/failedEmails/failed-email.service';

@Component({
  selector: 'failed-email',
  templateUrl: './failed-email.component.html',
  styleUrls: ['./failed-email.component.css']
})

export class FailedEmailComponent implements OnInit {

  failedEmails = [];
  pageSize: number = 20;
  currentPage = 0;
  pages;
  findByEmail = '';
  criteria = { handling_status: "SES_FAILURE" };
  fromDate;
  toDate;
  empty;
  mailToSend;
  toEmail;
  hasSysOpsPermission: boolean = false;

  constructor(
    protected failedEmailService: FailedEmailService,
    protected filterService: FilterService,
    protected adminService: AdminService,
    protected auth: Auth
    ) {}


  ngOnInit() {
    this.hasSysOpsPermission = this.auth.hasSysOpsPermission()
    this.adminService.getMe().then( user => {
      this.toEmail = user.email;
      this.fromDate = this.filterService.getDate();
      this.toDate = this.filterService.getDate();
      this.getWithCriteria();
    })
  }

  createdAt(emails: any[]) {
    for (let i = 0; i < emails.length; i++) {
      let date : any = new Date(emails[i].createdAt);
      date = date.toLocaleDateString("es-AR", "Argentina/Buenos Aires") + " " + date.toLocaleTimeString("es-AR", "Argentina/Buenos Aires");
      emails[i].createdAt = date;
    }
  }

  getWithCriteria() {

    this.failedEmails = [];
    this.criteria["page"] = this.currentPage;

    if(!_.isEmpty(this.findByEmail)) {
      this.criteria['recipient'] = this.findByEmail
    }

    if(_.isEmpty(this.findByEmail) && _.has(this.criteria, "recipient")) {
      delete this.criteria['recipient'];
    }

    if(!_.isEmpty(this.fromDate) && !_.isEmpty(this.toDate)) {
      this.criteria["from"] = this.fromDate;
      this.criteria["to"] = this.toDate;
    }

    return this.failedEmailService.get(this.criteria)
    .then( data => {

      if(data.total == 0) {
        this.empty = true
        return;
      };
      this.createdAt(data.emails);

      if(data.total % this.pageSize) {
        this.pages = Math.floor((data.total / this.pageSize));
      } else {
        this.pages = data.total / this.pageSize;
      }
      this.mailToSend = '';
      this.failedEmails = data.emails;
    })
    .catch( err => {
      return err && err._body ?
            (err._body.message ? alert(err._body.message) : alert(err))
            : alert(err);
    })
  }

  closeNoMatchesAlert() {
    this.empty = false;
  }

  backPage() {
    --this.currentPage;
    return this.getWithCriteria();
  }

  nextPage() {
    ++this.currentPage;
    return this.getWithCriteria();
  }

  setMail(mailId) {
    this.mailToSend = mailId;
  }

  sendFailedEmail(){
    const data = {
      mailId: this.mailToSend,
      toEmail: this.toEmail
    }
    return this.failedEmailService.sendFailedEmail(data)
    .then(() => {
      alert("Mail enviado satisfactoriamente, por favor revise su correo");
      location.reload();
    })
    .catch( err => {
      return err && err._body ?
            (err._body.message ? alert(err._body.message) : alert(err))
            : alert(err);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/failed-email/failed-email.component.ts